import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import React from "react";
import { Button } from "../../button";
import { IoSearch } from "react-icons/io5";
import { Label } from "@/components/ui/label";
import { DebouncedInput } from "../../debounced-input";
import { CircleButton } from "../../circle";
import { LuX } from "react-icons/lu";
import { cn } from "@/lib/utils";
import { useTableSearch } from "../data-table-context";

export function DataTableSearchPopover({
  children,
}: {
  children?: React.ReactNode;
}) {
  const {
    searchState: [search],
  } = useTableSearch();
  const isSearchActive = search !== undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          // variant={isSearchActive ? "midnight" : undefined}
          className={cn(
            "flex gap-1 justify-around",
            isSearchActive && "text-azure hover:text-azure hover:bg-ghost",
          )}
        >
          <IoSearch className="w-4 h-4" />
          {"Search"}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="mt-2">
        {children ?? <DataTableSearchContent />}
      </PopoverContent>
    </Popover>
  );
}

export function DataTableSearchContent() {
  const {
    searchLabel,
    searchState: [search, setSearch],
    searchValidation,
  } = useTableSearch();

  const isDirty = search !== undefined;
  return (
    <div data-component="data-table-search-content" className="space-y-2">
      {searchLabel && <Label>{searchLabel}</Label>}
      <div className="flex items-center gap-2">
        <DebouncedInput
          id="data-table-search"
          name="data-table-search"
          ref={(el) => el?.focus()}
          type="string"
          isUndefinable={true}
          value={search}
          onChange={setSearch as any}
          debounce={400}
          validate={searchValidation as any}
        />
        <CircleButton
          className={cn(isDirty ? "visible" : "invisible")}
          onClick={(_ev) => setSearch(undefined)}
        >
          <LuX />
        </CircleButton>
      </div>
    </div>
  );
}

export function DataTableSearchHybrid({
  children: _children,
}: {
  children?: React.ReactNode;
}) {
  const {
    searchLabel,
    searchState: [search, setSearch],
    searchValidation,
  } = useTableSearch();
  const isSearchActive = search !== undefined;
  return (
    <div
      className={cn(
        "transition-colors duration-100",
        "group flex items-center gap-1 pl-2 pr-1 justify-around focus-within:outline-azure/50 focus-within:outline-1 rounded-md border hover:text-ghost-foreground hover:bg-ghost/30",
        isSearchActive ? "border-azure ring-azure" : "border-aqua ring-aqua",
      )}
    >
      <IoSearch
        className={cn(
          "transition-colors duration-100",
          "w-4 h-4",
          isSearchActive && "text-azure",
        )}
      />
      <DebouncedInput
        id={`data-table-search-hybrid${searchLabel}`}
        name={`data-table-search-hybrid${searchLabel}`}
        inline={true}
        className={cn(
          "transition-colors duration-100",
          "h-8 w-auto text-ellipsis overflow-hidden placeholder-muted-foreground/60 text-muted-foreground focus-visible:text-foreground hover:text-foreground hover:placeholder-muted-foreground",
          isSearchActive && "text-muted-foreground hover:text-foreground",
          // isSearchActive && "text-azure hover:text-azure",
        )}
        // placeholder={`Search${searchLabel ? ` (${searchLabel})` : ""}`}
        placeholder={`Search${searchLabel ? ` ${searchLabel}` : ""}`}
        // ref={(el) => el?.focus()}
        type="string"
        isUndefinable={true}
        value={search}
        onChange={setSearch as any}
        debounce={400}
        validate={searchValidation as any}
      />
    </div>
  );
}

export const DataTableSearch = DataTableSearchHybrid;
